import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  shape, string, useDataModel, params, arrayOf, bool
} from '@thd-nucleus/data-sources';
import { ProductCategoryVisNavGrid } from './ProductCategoryVisNavGrid';

const ProductCategoryVisnav = (props) => {
  const { data } = props;
  const { visualNavs = [], visualNavContainsEvents } = data?.searchModel?.relatedResults || {};
  const { dimensions = [] } = data?.searchModel || {};

  let searchTerm = data?.searchModel?.searchReport?.keyword || '';

  const [urlAddOn, setUrlAddOn] = useState(null);

  const getUrlParameter = (name) => {
    if (typeof window === 'undefined') return '';
    try {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name) || '';
    } catch (error) {
      return '';
    }
  };

  const getUrlHashInfo = (hash) => {
    if (!hash) return '';
    try {
      const hashParams = new URLSearchParams(hash.replace(/^#/, ''));
      return hashParams.get('searchRedirect') || '';
    } catch (error) {
      return '';
    }
  };

  useEffect(() => {
    if (!searchTerm) {
      searchTerm = getUrlParameter('searchRedirect');
      if (typeof window !== 'undefined' && !searchTerm && window?.location?.hash) {
        searchTerm = getUrlHashInfo(window?.location?.hash || '');
      }
    }
    if (searchTerm) {
      setUrlAddOn(searchTerm);
    }
  }, []);

  return (
    <div data-component="ProductCategoryVisnav">
      <ProductCategoryVisNavGrid
        visualNavs={visualNavs}
        visualNavContainsEvents={visualNavContainsEvents}
        dimensions={dimensions}
        urlAddOn={urlAddOn}
      />
    </div>
  );
};

ProductCategoryVisnav.propTypes = {
  data: PropTypes.shape({
    searchModel: PropTypes.shape({
      relatedResults: PropTypes.shape({
        visualNavs: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            imageId: PropTypes.string,
            webUrl: PropTypes.string,
            categoryId: PropTypes.string,
            imageURL: PropTypes.string,
          })
        ),
        visualNavContainsEvents: PropTypes.bool,
      }),
      searchReport: PropTypes.shape({
        keyword: PropTypes.string,
      }),
      dimensions: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          refinements: PropTypes.arrayOf(
            PropTypes.shape({
              url: PropTypes.string,
              refinementKey: PropTypes.string,
            })
          ),
        })
      ),
    }),
  }).isRequired,
};

ProductCategoryVisnav.displayName = 'ProductCategoryVisnav';

ProductCategoryVisnav.dataModel = {
  searchModel: params({ keyword: string(), navParam: string() }).shape({
    metadata: shape({
      contentType: string(),
      hasPLPBanner: bool(),
    }),
    partialTemplates: arrayOf(string()),
    relatedResults: shape({
      visualNavs: arrayOf(
        shape({
          label: string(),
          imageId: string(),
          webUrl: string(),
          categoryId: string(),
          imageURL: string(),
        })
      ),
      visualNavContainsEvents: bool(),
    }),
    searchReport: shape({
      keyword: string(),
    }),
    dimensions: arrayOf(
      shape({
        label: string(),
        refinements: arrayOf(
          shape({
            url: string(),
            refinementKey: string(),
          })
        ),
      })
    ),
  }),
};
export { ProductCategoryVisnav };